module.exports = __webpack_public_path__ + "static/img/wanli.004f6da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/wanli.png
// module id = KIe2
// module chunks = 1